import React from 'react';
import { Link } from 'react-router-dom';
import CyberButton from '../UI/CyberButton';
import { motion } from 'framer-motion';
import MayaButton from "../UI/MayaButton";
import {scrollVariants, useScrollAnimation} from "../../hooks/useScrollAnimation";
import NeonText from '../UI/NeonText';
import HUDElement from '../UI/HUDElement';

const Hero = () => {
    const { ref, controls } = useScrollAnimation();

    return (
        <motion.section
            className="hero-section"
            ref={ref}
            initial="hidden"
            animate={controls}
            variants={scrollVariants}
        >
            <div className="hero-background">
                {/* Fondo con patrón maya sutil */}
                <div className="maya-hero-pattern"></div>
            </div>

            <div className="hero-content">
                <div className="hero-badge">
                    <span>K'INICH AJAW v2.1.4</span> {/* Dios sol maya */}
                </div>

                <h1 className="hero-title">
                    <span className="title-line">SABIDURÍA MAYA</span>
                    <span className="title-line accent">
            <NeonText variant="cyan">TECNOLOGÍA FUTURA</NeonText>
            <span className="blinking-cursor">_</span>
          </span>
                </h1>

                <p className="hero-subtitle">
                    Donde la cosmovisión ancestral se encuentra con la inteligencia artificial.
                    Creamos soluciones que honran el pasado mientras construimos el futuro.
                </p>

                <div className="hero-stats">
                    <div className="stat">
                        <HUDElement label="Kin" value={13} unit="" variant="compact" /> {/* Días sagrados */}
                    </div>
                    <div className="stat">
                        <HUDElement label="B'aktun" value={7} unit="" variant="compact" /> {/* Ciclos largos */}
                    </div>
                    <div className="stat">
                        <HUDElement label="Ch'een" value={99.9} unit="%" variant="compact" /> {/* Cenote/pozo */}
                    </div>
                </div>

                <div className="hero-actions">
                    <MayaButton
                        to="/contact"
                        variant="jade"
                        size="large"
                        withGlyph={true}
                    >
                        INICIAR K'ATUN
                    </MayaButton>

                    <MayaButton
                        to="/portfolio"
                        variant="volcanic"
                        size="large"
                        withGlyph={true}
                    >
                        VER CODICES
                    </MayaButton>
                </div>
            </div>

            {/* Líneas de conexión con estilo maya */}
            <div className="maya-connection-lines">
                <div className="maya-line"></div>
                <div className="maya-line"></div>
                <div className="maya-line"></div>
            </div>
        </motion.section>
    );
};

export default Hero;